<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="6" md="5" sm="6" cols="12">
          <v-card
            class="deposit-form"
            :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
          >
            <v-row>

              <!-- ================= BEFORE OTP ================= -->
              <template v-if="!mamWalletWithdrawDetails.otpsent">

                <!-- WITHDRAW METHOD -->
                <v-col cols="12">
                  <fieldset>
                    <legend>Withdraw Method</legend>
                    <v-select
                      v-model="withdrawMethod"
                      :items="withdrawMethods"
                      solo
                      append-icon="mdi-chevron-down"
                      label="Select Method"
                      class="custom-select"
                      hide-details
                    />
                  </fieldset>
                </v-col>

                <!-- FROM INVESTOR ACCOUNT (ALL METHODS) -->
                <v-col cols="12">
                  <fieldset>
                    <legend>Withdraw From Investor</legend>
                    <v-select
                      solo
                      :items="fromFormattedAccounts"
                      item-value="id"
                      item-text="displayText"
                      append-icon="mdi-chevron-down"
                      label="Select Trading Account"
                      class="custom-select"
                      hide-details
                      @change="fromAccountSelected"
                    />
                  </fieldset>

                  <!-- Helper line (inside v-col so padding/alignment works) -->
                  <!-- <div
                    v-if="formattedInvestorProfitUpdateDate"
                    class="profit-date d-flex align-center mt-2"
                    :class="$vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text text--darken-1'"
                  >
                    <v-icon
                      small
                      class="mr-1"
                      :class="$vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text text--darken-1'"
                    >
                      mdi-calendar
                    </v-icon>
                    <span>Profit Upto:</span>
                    <strong class="ml-1">{{ formattedInvestorProfitUpdateDate }}</strong>
                  </div> -->

                  <span v-if="error.fromAccountError" class="error-message">
                    {{ error.fromAccountError }}
                  </span>
                </v-col>

                <!-- CRYPTO ADDRESS -->
                <v-col v-if="withdrawMethod === 'Crypto'" cols="12">
                  <fieldset>
                    <legend>To Your Crypto Address</legend>
                    <v-select
                      v-model="wallet_address"
                      :items="addresses"
                      item-text="renamedAddress"
                      item-value="address"
                      solo
                      append-icon="mdi-chevron-down"
                      label="Select Crypto Address"
                      class="custom-select"
                      hide-details
                      @change="handleWalletAddress"
                    />
                  </fieldset>
                  <span v-if="error.wallet_address" class="error-message">
                    Please select a crypto address
                  </span>
                </v-col>

                <!-- BANK FIELDS -->
                <template v-if="withdrawMethod === 'Bank'">
                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>Bank Name</legend>
                      <v-select
                        v-model="selectedBank"
                        :items="banks"
                        item-text="bank_name"
                        item-value="id"
                        solo
                        append-icon="mdi-chevron-down"
                        class="custom-select"
                        hide-details
                        @change="handleBankChange"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>Bank Account No.</legend>
                      <v-text-field
                        v-model="bankAccountNumber"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>Account Name</legend>
                      <v-text-field
                        v-model="bankAccountName"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12" md="6">
                    <fieldset>
                      <legend>IFSC / Swift</legend>
                      <v-text-field
                        v-model="bankSwiftNum"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>

                  <v-col cols="12">
                    <fieldset>
                      <legend>Bank Address</legend>
                      <v-text-field
                        v-model="bankAddress"
                        solo
                        hide-details
                        readonly
                        class="custom-select"
                      />
                    </fieldset>
                  </v-col>
                </template>

                <!-- AMOUNT (ALL METHODS INCLUDING CASH) -->
                <v-col cols="12">
                  <fieldset>
                    <legend>Amount (USD)</legend>
                    <v-text-field
                      v-model="amount"
                      type="number"
                      min="1"
                      solo
                      hide-details
                      class="custom-select"
                    />
                  </fieldset>
                  <span v-if="error.amount_error" class="error-message">
                    {{ error.amount_error }}
                  </span>
                </v-col>

                <!-- SEND OTP -->
                <v-col cols="12">
                  <v-btn
                    @click.prevent="handleForm"
                    :loading="loading"
                    tile
                    class="btn-account d-block w-100"
                    color="greenMain"
                  >
                    Send OTP
                  </v-btn>
                </v-col>

              </template>

              <!-- ================= OTP ONLY ================= -->
              <template v-else>

                <v-col cols="12">
                  <fieldset>
                    <legend>Enter OTP Code</legend>
                    <v-text-field
                      v-model="verifiedCode"
                      type="number"
                      solo
                      hide-details
                      class="custom-select"
                      @input="limitDigits"
                    />
                  </fieldset>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    @click.prevent="submitForm"
                    :loading="loading2"
                    tile
                    class="btn-account d-block w-100"
                    color="greenMain"
                  >
                    Submit
                  </v-btn>
                </v-col>

              </template>

            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  MAM__WALLET__ACTIONS,
  WITHDRAWMETHODS__ACTIONS,
} from "@/store/action-types";

export default {
  data() {
    return {
      withdrawMethod: "Crypto",
      withdrawMethods: ["Crypto", "Bank", "Cash"],

      fromAccount: null,
      amount: null,

      wallet_address: null,
      network: "",

      selectedBank: null,
      bankAccountNumber: "",
      bankAccountName: "",
      bankSwiftNum: "",
      bankAddress: "",

      verifiedCode: null,
      loading: false,
      loading2: false,

      error: {
        fromAccountError: null,
        amount_error: null,
        wallet_address: false,
      },
    };
  },

  computed: {
    ...mapState("withdraw", ["addresses", "banks"]),
    ...mapState("mamWallet", [
      "mam_wallet_summary",
      "mamWalletWithdrawDetails",
    ]),

    fromFormattedAccounts() {
      const list = this.mam_wallet_summary?.investorAccountsProfit;
      if (!list || !list.length) return [];

      return list.map(acc => ({
        id: acc.trading_account_no,
        balance: Number(acc.available_profit),
        displayText: `${acc.trading_account_no} — Available Profit: ${Number(
          acc.available_profit
        ).toFixed(2)} USD`,
      }));
    },
    formattedInvestorProfitUpdateDate() {
      const raw = this.mam_wallet_summary?.investorProfitUpdateDate;
      if (!raw) return "N/A";

      const d = new Date(raw);

      // If backend already returns formatted string (or invalid date), show as-is
      if (isNaN(d.getTime())) return String(raw);

      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

  },

  watch: {
    withdrawMethod() {
      // reset irrelevant fields when switching method
      this.wallet_address = null;
      this.selectedBank = null;
      this.network = "";
    },
  },

  methods: {
    ...mapActions("withdraw", [
      WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS,
      WITHDRAWMETHODS__ACTIONS.BROKERSBANK,
    ]),
    ...mapActions("mamWallet", [
      MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY,
      MAM__WALLET__ACTIONS.MAMWALLETWITHDRAWCODE,
      MAM__WALLET__ACTIONS.CONFIRMMAMWALLETWITHDRAW,
    ]),

    fromAccountSelected(tradingAccountNo) {
      const acc = this.fromFormattedAccounts.find(
        a => a.id === tradingAccountNo
      );
      if (!acc) return;

      this.fromAccount = {
        trading_account_no: acc.id,
        balance: acc.balance,
      };
      this.error.fromAccountError = null;
    },

    handleWalletAddress() {
      const addr = this.addresses.find(
        a => a.address === this.wallet_address
      );
      this.network = addr?.network || "";
      this.error.wallet_address = false;
    },

    handleBankChange() {
      const b = this.banks.find(x => x.id === this.selectedBank);
      if (!b) return;
      this.bankAccountNumber = b.bank_acc_num;
      this.bankAccountName = b.bank_acc_name;
      this.bankSwiftNum = b.bank_swift_num;
      this.bankAddress = b.bank_address;
    },

    async handleForm() {
      this.error.fromAccountError = null;
      this.error.amount_error = null;
      this.error.wallet_address = false;

      if (!this.fromAccount) {
        this.error.fromAccountError = "Please select a trading account";
        return;
      }

      const amount = Number(this.amount);
      const available = Number(this.fromAccount.balance);

      if (!amount || amount <= 0) {
        this.error.amount_error = "Enter a valid amount";
        return;
      }

      if (amount > available) {
        this.error.amount_error = `Insufficient balance. Available: ${available.toFixed(
          2
        )} USD`;
        return;
      }

      if (this.withdrawMethod === "Crypto" && !this.wallet_address) {
        this.error.wallet_address = true;
        return;
      }

      if (this.withdrawMethod === "Bank" && !this.selectedBank) {
        this.error.amount_error = "Please select a bank";
        return;
      }

      this.loading = true;
      try {
        await this[MAM__WALLET__ACTIONS.MAMWALLETWITHDRAWCODE]({
          amount,
          trading_account_no: this.fromAccount.trading_account_no,
          withdraw_method: this.withdrawMethod,
          wallet_address:
            this.withdrawMethod === "Crypto" ? this.wallet_address : null,
          network:
            this.withdrawMethod === "Crypto" ? this.network : null,
          bank_id:
            this.withdrawMethod === "Bank" ? this.selectedBank : null,
        });
      } finally {
        this.loading = false;
      }
    },

    async submitForm() {
      this.loading2 = true;
      try {
        await this[MAM__WALLET__ACTIONS.CONFIRMMAMWALLETWITHDRAW]({
          code: this.verifiedCode,
        });
      } finally {
        this.loading2 = false;
      }
    },

    limitDigits() {
      if (this.verifiedCode?.length > 6) {
        this.verifiedCode = this.verifiedCode.slice(0, 6);
      }
    },
  },

  async mounted() {
    await this[WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS]();
    await this[WITHDRAWMETHODS__ACTIONS.BROKERSBANK]();
    await this[MAM__WALLET__ACTIONS.USERMAMWALLETSUMMARY]();
  },
};
</script>

<style scoped>
.error-message {
  color: #ff567f;
  font-size: 13px;
}
</style>
